import {axios} from 'api/api';

export default class UsStatesApi {
  static baseUrl = '/us-states';

  static getUSStates = (state, config) => {
    return axios.get(this.baseUrl, config);
  };
}
